export default {"src":"/_next/static/media/entretien-des-surfaces-engazonnees.4bd5db87.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};